import { Block, component } from '../../../scripts/core/Component'
import { GoogleMaps } from '../../../scripts/services/google-maps/GoogleMaps'

@component('map')
class Map extends Block {

  constructor (context) {
    super (context)

    const options = this.el.getAttribute('data-options');
    const pin = this.el.getAttribute('data-pin');

    try {
      this.options = JSON.parse(options)
    }
    catch (e) {
      console.error(e)
    }

    this.markerIcon = GoogleMaps.icon()
      .setUrl(pin)
      .setAnchor(19, 50)
      .setSize(60, 50)

    this.map = new GoogleMaps(context, this.options)

    this.options.markers.forEach((item) => {
      this.map.addMarker({
        position: item.position,
        icon: this.markerIcon
      }).then(() => {
        console.log('Marker is successfully set!')
      }).catch((e) => {
        console.error(e)
      })
    })

  }

  static providedBy (provider) {
    return function decorator (target) {
      target.map = provider
    }
  }
}

export {
  Map
}


// WEBPACK FOOTER //
// ./components/main/map/index.js